module.exports = __webpack_public_path__ + "static/media/VattenfallHall-Heavy.f74f7696.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/VattenfallHall-Heavy.eot
// module id = 138
// module chunks = 0